import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { isIOS, isAndroid } from "react-device-detect";
import { ASSETS } from "../../assets";
import * as S from "./AppBanner.styles";

const APP_STORE_URL = "https://apps.apple.com/be/app/rentio/id1435785897?l=nl";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=be.rentio.app&hl=nl";
const WEB_APP_URL = "https://rentio.be/nl-be/app";

interface IProps {}

export class AppBanner extends React.Component<IProps> {
  // Render
  public render() {
    return (
      <S.Wrap>
        <S.ButtonWrap onClick={this.handlePressOpenApp}>
          <S.InnerWrap>
            <S.AppIcon src={ASSETS.ICO_PHONE} />
            <S.TextWrap>
              <S.Title>{getLocalizedText("link.app_banner.title")}</S.Title>
              <S.Subtitle>
                {getLocalizedText("link.app_banner.subtitle")}
              </S.Subtitle>
            </S.TextWrap>
            <S.OpenAppButton onClick={this.handlePressOpenApp}>
              <S.OpenAppButtonText>
                {getLocalizedText("link.app_banner.cta.install_app")}
              </S.OpenAppButtonText>
            </S.OpenAppButton>
          </S.InnerWrap>
        </S.ButtonWrap>
      </S.Wrap>
    );
  }

  // Event handlers
  private handlePressOpenApp = async () => {
    let url = WEB_APP_URL;
    if (isIOS) {
      url = APP_STORE_URL;
    }
    if (isAndroid) {
      url = PLAY_STORE_URL;
    }
    window.open(url, "_blank");
  };
}
